module.exports = __webpack_public_path__ + "b8818245243f5cf4559bc174318c8f88.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/no-files-browser.png
// module id = 3635
// module chunks = 0